import React, { createContext, useContext, useState } from "react";

const AnalyticsContext = createContext(null);

const TIME_RANGES = [
  "Custom",
  "Today",
  "Yesterday",
  "7D",
  "30D",
  "3M",
  "6M",
  "12M",
];

export function AnalyticsProvider({ children }) {
  const [globalTimeRange, setGlobalTimeRange] = useState("30D");

  const value = {
    globalTimeRange,
    setGlobalTimeRange,
    TIME_RANGES,
  };

  return (
    <AnalyticsContext.Provider value={value}>
      {children}
    </AnalyticsContext.Provider>
  );
}

export function useAnalytics() {
  const ctx = useContext(AnalyticsContext);
  if (!ctx) throw new Error("useAnalytics must be used within AnalyticsProvider");
  return ctx;
}
